module.exports = __webpack_public_path__ + "img/search-icon.d9fc56bb.svg";